import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CheckBox from 'react-uwp/CheckBox';
import MaterialInput from 'components/form/MaterialInput/MaterialInput';

const ContantChangePassword4 = props => {
  const { password, error, onChangePassword } = props;

  const [showPassword, changeShowPassword] = useState(false);

  let errorString = null;
  if (error === 'SHORT_PASSWORD') {
    errorString = 'Mínimo 4 caracteres.';
  }

  return (
    <div>
      <MaterialInput
        type={showPassword ? 'text' : 'password'}
        name="password"
        label="Senha"
        value={password}
        info={errorString}
        infoLevel={error && 'warning'}
        infoMargin
        onChangeValue={onChangePassword}
      />
      <p>
        <CheckBox defaultChecked={showPassword} label="Exibir Senha" onCheck={changeShowPassword} />
      </p>
    </div>
  );
};

ContantChangePassword4.defaultProps = {
  error: null,
  onChangePassword: () => {},
};

ContantChangePassword4.propTypes = {
  password: PropTypes.string.isRequired,
  error: PropTypes.oneOf(['SHORT_PASSWORD']),
  onChangePassword: PropTypes.func,
};

export default ContantChangePassword4;
